// 如果您已集成 v2.x 的 SDK，想升级到 V3 并且想尽可能地少改动项目代码，可以继续沿用 TIM

// import TIM from '@tencentcloud/chat';
import TencentCloudChat from '@tencentcloud/chat';
import TIMUploadPlugin from 'tim-upload-plugin';
import Vue from "vue";
import Event from "./event";
import store from "@/store/index";
let eventInstance = new Event();
// 这是本地审核插件 未安装 需要 npm 安装
// import TIMProfanityFilterPlugin from 'tim-profanity-filter-plugin';

let options = {
	SDKAppID: 1721000626,//这是即时通信IM应用的SDKAPP ID
};

// 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
let chat = TencentCloudChat.create(options); // SDK 实例通常用 chat 表示

let env = process.env.NODE_ENV;

let logLevel = 0;
if(env == "development"){
	logLevel = 0;
}
else if(env == "production"){
	logLevel = 1;
}

// chat.setLogLevel(logLevel); // 普通级别，日志量较多，接入时建议使用
chat.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用

// 注册腾讯云即时通信 IM 上传插件
chat.registerPlugin({'tim-upload-plugin': TIMUploadPlugin});

// 变量赋值
let $TencentCloudChat = TencentCloudChat;
let $TencentCloudChatEvent = TencentCloudChat.EVENT;
let $TencentCloudChatType = TencentCloudChat.TYPES;
let $SKD_STATUS = {
	$SKD_READY: false,
	$LOGIN_SUCCESS: false,
};
// 监听事件

// 监听SDK READY 事件
chat.on(TencentCloudChat.EVENT.SDK_READY,(event)=>{
	console.log("TencentCloudChat.EVENT.SDK_READY");
	$SKD_STATUS.$SKD_READY = true;
	eventInstance.emit("TencentCloudChat.EVENT.SDK_READY", {
		event
	});
});


// 监听SDK NOT_READY 事件
chat.on(TencentCloudChat.EVENT.SDK_NOT_READY,(event)=>{
	$SKD_STATUS.$SKD_READY = false;
	// console.log("TencentCloudChat.EVENT.SDK_NOT_READY",event);
	eventInstance.emit("TencentCloudChat.EVENT.SDK_NOT_READY",{
		event
	});
});

// 接收到消息
chat.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, (event)=>{
	console.log("TencentCloudChat.EVENT.MESSAGE_RECEIVED");
	eventInstance.emit("TencentCloudChat.EVENT.MESSAGE_RECEIVED",{
		event
	});
});

// 消息被撤回
chat.on(TencentCloudChat.EVENT.MESSAGE_REVOKED, (event)=>{
	console.log("TencentCloudChat.EVENT.MESSAGE_REVOKED");
	eventInstance.emit("TencentCloudChat.EVENT.MESSAGE_REVOKED",{
		event
	});
});

// 对端消息已读
chat.on(TencentCloudChat.EVENT.MESSAGE_READ_BY_PEER, (event)=>{
	// console.log("TencentCloudChat.EVENT.MESSAGE_READ_BY_PEER");
	eventInstance.emit("TencentCloudChat.EVENT.MESSAGE_READ_BY_PEER",{
		event
	});
});

// 用户被踢下线
chat.on(TencentCloudChat.EVENT.KICKED_OUT, (event)=>{
	// console.log("TencentCloudChat.EVENT.KICKED_OUT");
	// console.log(event.data.type,"======");
	// TencentCloudChat.TYPES.KICKED_OUT_MULT_ACCOUNT(Web端，同一账号，多页面登录被踢)
	// TencentCloudChat.TYPES.KICKED_OUT_MULT_DEVICE(同一账号，多端登录被踢)
	// TencentCloudChat.TYPES.KICKED_OUT_USERSIG_EXPIRED(签名过期)
	// TencentCloudChat.TYPES.KICKED_OUT_REST_API(REST API kick 接口踢出)

	eventInstance.emit("TencentCloudChat.EVENT.KICKED_OUT",{
		event
	});
});

// 网络状态发生变化时
chat.on(TencentCloudChat.EVENT.NET_STATE_CHANGE, (event)=>{
	// event.data.state 当前网络状态，枚举值及说明如下：
	// TencentCloudChat.TYPES.NET_STATE_CONNECTED - 已接入网络
	// TencentCloudChat.TYPES.NET_STATE_CONNECTING
	// 连接中。很可能遇到网络抖动，SDK 在重试。接入侧可根据此状态提示“当前网络不稳定”或“连接中”
	// TencentCloudChat.TYPES.NET_STATE_DISCONNECTED
	// 未接入网络。接入侧可根据此状态提示“当前网络不可用”。SDK 仍会继续重试，若用户网络恢复，SDK 会自动同步消息
});

// 会话列表发生变化时
chat.on(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED, (event)=>{
	eventInstance.emit("TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED",{
		event
	});
});

// 未读消息数目发生变化
chat.on(TencentCloudChat.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED, (event)=>{
	// console.error("TencentCloudChat.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED",event);
	store.dispatch("getIMMsgUnreadCount",event.data);
	eventInstance.emit("TencentCloudChat.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED", {
		event
	});
});

export {
	chat,
	$TencentCloudChat,
	$TencentCloudChatEvent,
	$TencentCloudChatType,
	$SKD_STATUS,
	eventInstance
};
